var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tag is-success"},[_c('icon',{attrs:{"icon":"check"}}),_c('span',[_vm._v("Resolved")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }